/**
 * Mobility Element Colors — default color per mappable element type
 *
 * @module core/modules/mobility/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo de movilidad
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 mobility element types that have map representation */
export type MobilityElementId =
  | 'stops'
  | 'routes'
  | 'bikeways'
  | 'pedestrian'
  | 'parking'
  | 'signage';

export const MOBILITY_ELEMENT_COLORS: Record<MobilityElementId, string> = {
  'stops':      '#3b82f6', // azul (paradas de transporte)
  'routes':     '#8b5cf6', // violeta (rutas de transporte)
  'bikeways':   '#10b981', // verde (ciclovías)
  'pedestrian': '#f59e0b', // ámbar (zonas peatonales)
  'parking':    '#6366f1', // índigo (estacionamientos)
  'signage':    '#ef4444', // rojo (señalización)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(MOBILITY_ELEMENT_COLORS),
);
